import Constants from "../utils/consts";
import Utils from "../utils/utils";
import { safeJsonParse } from "../utils/jsonParser";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function getPresenze(uname, token, id_lezione) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getPresenze.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        try {
          const resp = safeJsonParse(body.toString(), "getPresenze");
          console.log(
            "[getPresenze] Risposta backend (sample):",
            resp.slice(0, 3)
          );
          resolve(resp);
        } catch (error) {
          console.error("[getPresenze] ERRORE nel parsing JSON:", error);
          reject(error);
        }
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_lezione: id_lezione,
    });

    req.write(postData);

    req.end();
  });
}
